<template>
  <div class="container table-card">
    <CustomLoader ref="loader"/>
    <div class="table-header-container" v-if="tableId">
      <slot name="header-options"/>
      <SearchArray v-if="!disableSearch" :elements="elements" ref="searchArray"/>
    </div>
    <table v-if="tableId">
      <slot name="table"/>
    </table>
    <PaginationArray v-if="tableId" :defaultIndex="defaultIndex" :defaultPages="defaultItemsPerPages" id="paginationArray" ref="paginationArray"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLemon } from "@fortawesome/free-solid-svg-icons";
import PaginationArray from "@/components/PaginationArray.vue";
import SearchArray from "@/components/SearchArray.vue";
import CustomLoader from "@/components/CustomLoader.vue";
import { CustomTableService } from "@/services/CustomTableService";
import { provide } from "vue";
library.add(faLemon);

export default {
  name: 'CustomTable',
  components: {
    CustomLoader,
    SearchArray,
    PaginationArray
  },
  props: ['elements', 'defaultItemsPerPages', 'defaultIndex', 'disableSearch', 'loadData', 'searchOptions'],
  data() {
    return {
      loading: false,
      tableId: undefined,
    };
  },
  created() {
    this.tableId = CustomTableService.init(this.data, this.loadData);
    provide("tableId", this.tableId);
  },
  mounted() {
    if (this.searchOptions) {
      this.$refs.searchArray.initParams(
          this.searchOptions.filters,
          this.searchOptions.sorts
      );
    }
  },
  methods: {
    buildURLParams() {
      let paramsBuilder = "?";

      paramsBuilder += this.$refs.paginationArray
          ? this.$refs.paginationArray.urlParamsBuilder()
          : "";

      paramsBuilder += this.$refs.searchArray
          ? this.$refs.searchArray.urlParamsBuilder()
          : "";

      return paramsBuilder === "?" ? "" : paramsBuilder;
    },
    startLoading() {
      this.$refs.loader?.startLoading();
    },
    stopLoading() {
      this.$refs.loader?.stopLoading();
    }
  }
}

</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl'

// Le tableau est une carte : barre d'outils (interrupteur, recherche, action), tableau, pagination
.container
  position relative
  // Les largeurs des colonnes (cqw) se calculent sur la largeur de la carte, pas sur celle de la fenêtre
  container-type inline-size
  width 100%
  max-width 100%
  min-width 0
  margin-top 20px
  border 1px solid PAGE_RULE
  border-radius 14px
  background-color white
  box-shadow 0 1px 0 rgba(23, 35, 63, 0.04), 0 10px 26px -18px rgba(23, 35, 63, 0.35)

.table-header-container
  display flex
  align-items flex-start
  flex-wrap wrap
  gap 12px
  padding 14px 16px

  // Les boutons d'action (Nouveau devis, Exporter, +…) se placent en fin de ligne, à droite
  // (isolés des filtres : ils agissent sur les données, les filtres ne font que les afficher)
  :deep(.action-button), :deep(.button-icon)
    order 10
    margin-right 0
    margin-left auto

  :deep(.action-button + .action-button), :deep(.button-icon + .button-icon)
    margin-left 0

table
  width 100%
  max-width 100%
  table-layout fixed
  border-collapse collapse
  margin auto
  text-align left
  font-family inherit

  :deep(th),
  :deep(td)
    font-size 14px
    width auto
    min-width 0

  // En-tête : texte bleu principal sur fond papier, filet épais dessous
  :deep(th)
    padding 12px 10px
    background-color #FAFBF7
    color THEME_COLOR_PRIMARY
    font-weight 700
    border-bottom 2px solid THEME_COLOR_PRIMARY

  // Même respiration à gauche et à droite dans tous les tableaux (la première colonne ne colle plus au bord de la carte)
  :deep(td)
    padding 2px 10px
    color #3f3931
    border-bottom 1px solid PAGE_RULE_SOFT

  :deep(tbody tr:last-child td)
    border-bottom 0

  // Survol : citron clair et liseré citron sur la première cellule
  :deep(tbody tr:hover)
    background-color PAGE_LEMON_HOVER !important

  :deep(tbody tr:hover td:first-child)
    box-shadow inset 3px 0 0 PAGE_LEMON

  :deep(tbody tr)
    height 40px
</style>
